import { InlineMessage } from "@amzn/storm-ui";
import styled from "styled-components";

export const StylesInlineMessage = styled(InlineMessage)`
  margin-top:0.25rem;
`